import { Config } from "../../../_config/index.ts"
import { GQLClient } from "../../../_fetcher/GQLClient.ts"
import { ProjectConfig } from "../../Models/ProjectConfig.ts"
import { ProjectStats } from "../../Models/ProjectStats.ts"
import { GET_PROJECT_CONFIG_QUERY, type GetProjectConfigQueryResponse } from "./queries/GetProjectConfigQuery.ts"
import { GET_PROJECT_STATS_QUERY, type GetProjectStatsQueryResponse } from "./queries/GetProjectStatsQuery.ts"
import { ProjectRepository } from "../ProjectRepository.ts"

export class GQLProjectRepository implements ProjectRepository {
  static create(config: Config) {
    const gqlFetcher = GQLClient.create(config)
    return new GQLProjectRepository(gqlFetcher)
  }

  constructor(private readonly _gqlFetcher: GQLClient) {}

  async getProjectConfig() {
    const gqlResponse = await this._gqlFetcher.request<object, GetProjectConfigQueryResponse>({
      query: GET_PROJECT_CONFIG_QUERY,
    })

    const response = gqlResponse?.getProjectConfiguration
    if (!response) throw new Error("Missing getProjectConfiguration")

    return ProjectConfig.createFromAPI(response)
  }

  async getProjectStats() {
    const gqlResponse = await this._gqlFetcher.request<object, GetProjectStatsQueryResponse>({
      query: GET_PROJECT_STATS_QUERY,
    })

    const response = gqlResponse?.getDEXStats
    if (!response) throw new Error("Missing getDEXStats")

    return ProjectStats.createFromAPI(response)
  }
}
